<style>
.multiselect__content-wrapper {
  position: relative;
}

.character-option-icon {
  margin: 0 6px 0 0;
  height: 22px;
}

.character-label-icon {
  margin: 0 6px 0 0;
  height: 26px;
}

.map_holder {
  width: 100%;
  height: 450px;
}

.fa-minus-circle {
  color: #e74c3c;
  cursor: pointer;
}
.fa-plus-circle {
  color: #27c24c;
  cursor: pointer;
}

.redes {
  display: inline-block;
  width: calc(100% - 45px);
}
</style>
<template>
  <admin-layout>
    <template v-slot:breadcrumb>
      <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
        <li class="breadcrumb-item text-sm">
          <a class="opacity-5 text-white" href="javascript:;">Admin</a>
        </li>
        <li class="breadcrumb-item text-sm text-white" aria-current="page">
          Serviços
        </li>
        <li class="breadcrumb-item text-sm text-white" aria-current="page">
          Aprovação de Serviços
        </li>
      </ol>
    </template>

    <template v-slot:header>
      <h5 class="font-weight-bolder text-white mt-4 mb-0">
        Aprovação de Serviços
      </h5>
    </template>

    <template #content>
      <div class="row">
        <div class="col-12">
          <div class="card mb-4">
            <div class="card-header pb-0">
              <div class="row">
                <div class="col-8"></div>

                <div class="col-4">
                  <div class="input-group">
                    <input
                      v-model="filter"
                      @keyup="search"
                      type="text"
                      class="form-control"
                      placeholder="Pesquisar"
                    />
                    <span class="input-group-text text-body"
                      ><i
                        @click="search"
                        class="fas fa-search"
                        style="cursor: pointer"
                        aria-hidden="true"
                      ></i
                    ></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-body px-0 pt-0 pb-2">
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        #
                      </th>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Detalhes
                      </th>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Titulo
                      </th>

                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Subcategoria
                      </th>

                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Endereço
                      </th>

                      <th class="text-secondary opacity-7"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(servico, index) in servicosEmRevisao.data"
                      :key="index"
                    >
                      <td>
                        <div class="px-4 py-1">
                          <div class="justify-content-center">
                            <input
                              type="checkbox"
                              :id="servico.id"
                              :value="servico.id"
                              v-model="form.servicoChecked"
                            />
                          </div>
                        </div>
                      </td>

                      <td class="px-4 py-1">
                        <i
                          style="cursor: pointer"
                          class="fas fa-user-plus text-primary"
                          @click="view(servico)"
                        ></i>
                      </td>

                      <td>
                        <div class="px-4 py-1">
                          <div class="justify-content-center">
                            <h6 class="mb-0 text-sm">
                              {{ servico.titulo }}
                            </h6>
                            <!--        <p class="text-xs text-secondary mb-0">
                              john@creative-tim.com
                            </p> -->
                          </div>
                        </div>
                      </td>

                      <td>
                        <div class="px-4 py-1">
                          <div class="justify-content-center">
                            <h6 class="mb-0 text-sm">
                              {{ servico.subcategoria.descricao }}
                            </h6>
                            <!--        <p class="text-xs text-secondary mb-0">
                              john@creative-tim.com
                            </p> -->
                          </div>
                        </div>
                      </td>

                      <td>
                        <div class="px-4 py-1">
                          <div class="justify-content-center">
                            <h6 class="mb-0 text-sm">
                              {{ servico.endereco }}
                            </h6>
                            <!--        <p class="text-xs text-secondary mb-0">
                              john@creative-tim.com
                            </p> -->
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-if="form.servicoChecked.length > 0" class="card-footer">
              <button @click.prevent="aprovar" class="btn btn-primary btn-sm">
                Aprovar
              </button>
              <button
                @click.prevent="openModalRecusa"
                class="mx-3 btn btn-danger btn-sm"
              >
                Recusar
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </admin-layout>

  <div
    class="modal fade"
    id="modalServico"
    tabindex="-1"
    aria-labelledby="modalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <form>
          <div class="modal-header">
            <h5 class="modal-title" id="modalLabel">Visualizar Serviço</h5>
            <span
              style="cursor: pointer"
              @click="closeModal"
              aria-label="Close"
              aria-hidden="true"
              >×</span
            >
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Título</label
                  >
                  <input
                    v-model="servico.titulo"
                    class="form-control"
                    type="text"
                    onfocus="focused(this)"
                    onfocusout="defocused(this)"
                    disabled
                  />
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Endereço</label
                  >
                  <input
                    v-model="servico.endereco"
                    class="form-control"
                    type="text"
                    onfocus="focused(this)"
                    onfocusout="defocused(this)"
                    disabled
                  />
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Categoria</label
                  >
                  <input
                    v-model="servico.subcategoria.categoria.descricao"
                    class="form-control"
                    type="text"
                    onfocus="focused(this)"
                    onfocusout="defocused(this)"
                    disabled
                  />
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Subcategoria</label
                  >
                  <input
                    v-model="servico.subcategoria.descricao"
                    class="form-control"
                    type="text"
                    onfocus="focused(this)"
                    onfocusout="defocused(this)"
                    disabled
                  />
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Contato</label
                  >
                  <input
                    v-model="servico.contato"
                    class="form-control"
                    type="text"
                    onfocus="focused(this)"
                    onfocusout="defocused(this)"
                    disabled
                  />
                </div>
              </div>

              <!-- teste corte de imagem -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <a
                      class="btn"
                      v-bind:class="{ disabled: checkbtn }"
                      @click="toggleShow2"
                      >Carregar Imagem</a
                    >

                    <my-upload
                      field="img"
                      @crop-success="cropSuccess"
                      @crop-upload-success="cropUploadSuccess"
                      @crop-upload-fail="cropUploadFail"
                      v-model="show"
                      :width="1280"
                      :height="720"
                      :url="urlBase"
                      :params="params"
                      :headers="headers"
                      :maxSize="5024"
                      :noCircle="true"
                      img-format="png"
                      langType="pt-br"
                    >
                    </my-upload>

                    <br />

                    <div
                      v-if="checkbtn"
                      class="invalid-feedback mb-3"
                      :class="{ 'd-block': checkbtn }"
                    >
                      Não é possível adicionar fotos antes da aprovação
                      cadastral.
                    </div>

                    <div
                      class="invalid-feedback mb-3"
                      :class="{ 'd-block': form.errors.img }"
                    >
                      {{ form.errors.img }}
                    </div>

                    <ul class="image-list">
                      <li
                        class="list"
                        v-for="(item, index) in imgDataList"
                        :key="index"
                      >
                        <!--           <a
                          v-if="imgDataList"
                          class="btn btn-icon btn-2 btn-danger"
                          style="
                            padding: 1px 4px;
                            right: -20px;
                            top: -30px;
                            position: relative;
                          "
                          @click="removerImg(index, item)"
                        >
                          <i class="ni ni-fat-delete"></i>
                        </a> -->
                        <img
                          v-if="item"
                          :src="'/storage/img/' + setor + '/' + item"
                          width="150"
                          height="100"
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!--- teste corte de imagem --->

              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Tags</label
                  >

                  <multiselect
                    v-model="servico.tags"
                    :multiple="true"
                    :option-height="104"
                    :taggable="true"
                    label="descricao"
                    :options="servico.tags"
                    disabled
                  >
                  </multiselect>
                </div>
              </div>

              <div class="col-md-12">
                <label for="example-text-input" class="h5"
                  >Mídias Sociais</label
                >

                <div
                  class="form-group"
                  v-for="(input, k) in servico.redes"
                  :key="k"
                >
                  <div class="row">
                    <div class="col-4">
                      <label for="example-text-input" class="form-control-label"
                        >Mídia Social</label
                      >

                      <input
                        type="text"
                        class="form-control"
                        v-model="input.descricao"
                        disabled
                      />
                    </div>
                    <div class="col-5">
                      <label for="example-text-input" class="form-control-label"
                        >Link</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-model="input.pivot.link"
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Descrição</label
                  >
                  <textarea
                    v-model="servico.descricao"
                    class="form-control"
                    onfocus="focused(this)"
                    onfocusout="defocused(this)"
                    disabled
                    rows="4"
                  >
                  </textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!--        <button type="button" class="btn btn-secondary" @click="closeModal">
              Fechar
            </button> -->
          </div>
        </form>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="modalRecusa"
    tabindex="-1"
    aria-labelledby="modalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <form>
          <div class="modal-header">
            <h5 class="modal-title" id="modalLabel">Recusar Serviço</h5>
            <span
              style="cursor: pointer"
              @click="closeModalRecusa"
              aria-label="Close"
              aria-hidden="true"
              >×</span
            >
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Motivo da Recusa</label
                  >
                  <input
                    v-model="form.motivo_recusa"
                    class="form-control"
                    type="text"
                    onfocus="focused(this)"
                    onfocusout="defocused(this)"
                    :class="{ 'is-invalid': form.errors.motivo_recusa }"
                  />
                </div>
                <div
                  class="invalid-feedback mb-3"
                  :class="{ 'd-block': form.errors.motivo_recusa }"
                >
                  {{ form.errors.motivo_recusa }}
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              required
              class="btn btn-danger"
              @click="recusar"
            >
              Recusar
            </button>

            <button
              type="button"
              class="btn btn-secondary"
              @click="closeModalRecusa"
            >
              Fechar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import Pagination from "@/Components/Pagination";
import { Link } from "@inertiajs/inertia-vue3";
import myUpload from "vue-image-crop-upload";

export default {
  props: ["servicosEmRevisao", "setor", "prefeitura_url"],
  components: {
    "my-upload": myUpload,
    AdminLayout,
    Pagination,
    Link,
  },

  data() {
    return {
      modal: Object,
      modalRecusa: Object,

      show: false,
      urlBase:
        "/admin/galeria/uploadimg/" + this.setor + "/" + this.prefeitura_url,
      arquivo_nome: "",
      params: {
        setor: this.setor,
      },
      headers: {
        smail: "*_~",
      },
      imgDataUrl: "",
      imgDataList: [],

      form: this.$inertia.form({
        servicoChecked: [],
        motivo_recusa: "",
      }),

      filter: "",
      servico: {
        id: "",
        titulo: "",
        contato: "",
        img: "",
        descricao: "",
        subcategoria_id: "",
        tags: [],
        latitude: "",
        longitude: "",
        endereco: "",

        redes: [
          {
            descricao: "",
            pivot: {
              link: "",
            },
          },
        ],
        subcategoria: {
          id: "",
          descricao: "",
          categoria: {
            id: "",
            descricao: "",
          },
        },
      },
    };
  },
  computed: {
    checkbtn() {
      if (this.imgDataList.length >= 6) {
        return true;
      } else {
        return true;
      }
    },
  },

  methods: {
    //INICIO - Corte de Imagem
    toggleShow2() {
      this.show = !this.show;
    },

    removerImg(index, item) {
      this.imgDataList.splice(index, 1);
      console.log(this.imgDataList);
      axios.post("/admin/galeria/removerimg", { file: item });
    },

    cropSuccess(imgDataUrl, field) {
      console.log("-------- crop success --------");
      this.imgDataUrl = imgDataUrl;
    },

    cropUploadSuccess(jsonData, field) {
      this.imgDataList.push(jsonData.file);
      console.log("-------- upload success --------");
      console.log(jsonData);
      console.log("Arquivo: " + jsonData.file);
      console.log("Arquivo List: " + this.imgDataList);
      console.log("field: " + field);
      console.log("----------------- FORMULÁRIO -------------------");
      console.log(this.form);
    },

    cropUploadFail(status, field) {
      console.log("-------- upload fail --------");
      console.log(status);
      console.log("field: " + field);
    },
    //FIM - Corte de Imagem

    openModal() {
      this.imgDataList = [];
      this.form.clearErrors();
      this.modal.show();
      this.form.reset();
    },

    openModalRecusa() {
      this.modalRecusa.show();
    },

    closeModalRecusa() {
      this.modalRecusa.hide();
    },

    closeModal() {
      this.modal.hide();
      this.form.clearErrors();
    },

    recusar() {
      this.form.post(this.route("admin.servicos.recusar"), {
        preserveScroll: true,
        onSuccess: () => {
          this.form.reset();
          this.closeModalRecusa();
        },
      });
    },

    aprovar() {
      this.form.img = this.imgDataList;
      this.form.post(this.route("admin.servicos.aprovar"), {
        preserveScroll: true,
        onSuccess: () => {
          this.form.reset();
        },
      });
    },

    view(servico) {
      this.openModal();
      this.servico = Object.assign(this.servico, servico);
      this.imgDataList = Object.values(servico.img);
    },

    search() {
      this.$inertia.get(
        route("admin.servicos.index"),
        {
          filter: this.filter,
        },
        { preserveState: true }
      );
    },
  },
  created() {},
  mounted() {
    this.modal = new bootstrap.Modal(
      document.getElementById("modalServico"),
      {}
    );

    this.modalRecusa = new bootstrap.Modal(
      document.getElementById("modalRecusa"),
      {}
    );
  },
};
</script>

<style>
li.list {
  float: left;
  padding: 5px;
}
ul.image-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
</style>
